
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { FileItemProps, FileMineType } from ".";
import { loading, index } from "store/file";

interface ApiFileInputProps {
    folderId: -1 | number;
    type?: FileMineType[];
}

type ApiFileOutputProps = OutputBaseProps<{ list: FileItemProps[] }>;

export const apiFileIndex = async (data: ApiFileInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiFileOutputProps>("/api/files", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, folderId: data.folderId > -1 ? data.folderId : undefined }));
    }
    return res;
};